import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Spinner } from "@/components/ui";
import { usePaymentConfig } from "./api";

/** The classic card/wallet subscription page only exists when Flutterwave billing is on. */
export function ClassicSubscriptionGate({ children }: { children: ReactNode }) {
  const config = usePaymentConfig();
  if (config.isLoading)
    return (
      <div className="grid min-h-[40dvh] place-items-center">
        <Spinner className="size-6 text-cyan" label="Loading" />
      </div>
    );
  if (config.data?.mode === "manual") return <Navigate to="/billing" replace />;
  return <>{children}</>;
}
